/* eslint-disable comma-dangle */ /* eslint-disable comma-dangle */
<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
// import share from './components/share';

export default {
  name: 'App'
};
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
  /* margin-top: 16px; */
}
*{
  margin: 0;
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue